export default {
  isValidAddress(address) {
    const SINGLE_KEY_ACC = "k:";
    if (!address.substring(0, 2) === SINGLE_KEY_ACC) {
      return false;
    }
    return /^k:[0-9a-fA-F]{64}$/.test(address);
  },
};
